export default "I er pirater, og I er lige gået i land på en vaskeægte skatteø. I har fundet en grotte og et skib, men kan I også finde skatten?";